import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import IconLB from '../../../app/main/design-system/components/icons/Icon';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '12px 5px',
    fontSize: 11,
    fontWeight: 600,
    height: 16,
    minWidth: 16,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
}));

function FuseNavBadge(props) {
  const classes = useStyles(props);
  const { className, badge } = props;

  return (
    <div
      className={clsx(classes.root, className, 'item-badge')}
      style={{
        backgroundColor: badge.bg,
        color: badge.fg,
      }}
    >
      {badge.icon ? <IconLB name={badge.icon} color="#FFF" size={15} /> : badge.title}
    </div>
  );
}

FuseNavBadge.propTypes = {
  badge: PropTypes.shape({
    title: PropTypes.node,
    bg: PropTypes.string,
    fg: PropTypes.string,
  }),
};
FuseNavBadge.defaultProps = {};

export default React.memo(FuseNavBadge);
